import { Input, Modal, notification } from 'antd';
import agent from 'App/api/agent/agent';
import { scrapeEventFromHtml } from 'App/common/utils/import/eventImporter.utils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ProxyEventImportModalProps {
	open: boolean;
	onOk: (data: any) => void;
    onCancel: () => void;
}

export const ProxyEventImportModal = ({ open, onOk, onCancel }: ProxyEventImportModalProps) => {
	const { t } = useTranslation(['page', 'common']);
	const [importUrl, setImportUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const timestampToDate = (timestamp: number | null) => {
        let d = timestamp ? new Date(timestamp * 1000) : new Date();
        let formatDate = d.getFullYear() + "-" +  
                         ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
                         ("0" + d.getDate()).slice(-2) + "T" + 
                         ("0" + d.getHours()).slice(-2) + ":" + 
                         ("0" + d.getMinutes()).slice(-2) + ":" + 
                         ("0" + d.getSeconds()).slice(-2);
        return formatDate;
    }

	const handleOk = async () => {
        setIsLoading(true);
		let data = null;

		try {
			const html = await agent.Proxy.getFacebookPageByUrl({ url: importUrl });
            if (html === null || html.length === 0)
                throw Error();

			const eventData = await scrapeEventFromHtml(html);
            if (eventData == null)
                throw Error();

            const locationData = eventData.location ? {
                locationName: eventData.location.name,
                street: eventData.location.address,
                city: eventData.location.city?.name,
                country: eventData.location.countryCode ?? "PL",
                latitude: eventData.location.coordinates?.latitude ?? 0,
                longitude: eventData.location.coordinates?.longitude ?? 0,
            } : {
                country: "PL",
                latitude: 0,
                longitude: 0,
            }

			data = {
				title: eventData.name,
				organizer: eventData.hosts.map(h => h.name).join(", "),
				dateStart: timestampToDate(eventData.startTimestamp),
				dateEnd: eventData.endTimestamp ? timestampToDate(eventData.endTimestamp) : timestampToDate(eventData.startTimestamp + 3*60*60),
				isWholeDay: false,
				timezone: eventData.timezone,
				priceCurrency: 'PLN',
				externalLink: eventData.url,
				safetyCageRequired: null,
				categories: [],
				status: 'Verified',
				surfaces: [],
				tags: [],
                ...locationData,
			};
		} catch (err) {
			console.error(err);
			notification.error({
				message: t('common:Errors.Error'),
				description: t('common:Errors.AnErrorOccured'),
			});
		} finally {
            setIsLoading(false);
            setImportUrl(null);
			onOk(data);
		}
	};

    const handleCancel = () => {
        setImportUrl(null);
        onCancel();
    }

	return (
		<Modal
            open={open} 
            onOk={handleOk} 
            onCancel={handleCancel}
            confirmLoading={isLoading}
            title={t('common:Actions.Import')}
        >
			<Input onChange={(value) => setImportUrl(value.target.value)} value={importUrl} />
		</Modal>
	);
};
